export const storeName = 'auth';

export default {
  isLoggedIn: false,
  authConfig: null,
};
